const accessAuth = {

    LOGIN: {
        path: '/login'
    },

    UNKNOWN_PATH: {
        path: '*'
    }

}

export default accessAuth;